module.exports = __webpack_public_path__ + "static/media/p2008mot1.d4d45f1e.jpg";